import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
} from 'react';

export type AccountType = 'demo' | 'live';

interface AccountTypeContextType {
  accountType: AccountType;
  isDemoAccount: boolean;
  setAccountType: (type: AccountType) => void;
  toggleAccountType: () => void;
}

const AccountTypeContext = createContext<AccountTypeContextType | undefined>(undefined);

export const useAccountType = () => {
  const context = useContext(AccountTypeContext);
  if (context === undefined) {
    throw new Error('useAccountType must be used within an AccountTypeProvider');
  }
  return context;
};

interface AccountTypeProviderProps {
  children: ReactNode;
}

export const AccountTypeProvider: React.FC<AccountTypeProviderProps> = ({ children }) => {
  const [accountType, setAccountType] = useState<AccountType>('demo');

  const toggleAccountType = () => {
    setAccountType(prev => prev === 'demo' ? 'live' : 'demo');
  };

  const value: AccountTypeContextType = {
    accountType,
    isDemoAccount: accountType === 'demo',
    setAccountType,
    toggleAccountType,
  };

  return <AccountTypeContext.Provider value={value}>{children}</AccountTypeContext.Provider>;
};
